import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import { employeesShortNamesAndI } from '../employees/employees-short-names-and-i';
import { joinWithAnd } from '../../../utilities/text';
import { toList } from '../toList';

export const functionsWithEmployeeNames = createSelector(
  getOrganization,
  employeesShortNamesAndI,
  (
    organization,
    employeesShortNamesAndIList,
  ): {
    uuid: string;
    type: string;
    name: string;
    employees: string[];
  }[] => {
    if (organization === undefined) return [];
    const result: { uuid: string; type: string; name: string; employees: string[] }[] = [];
    const functions = toList(organization.functionsById).filter((e) => !e.deleted && e.isConfirmedEntity);
    functions.forEach(function (item) {
      const namesList: string[] = [];
      employeesShortNamesAndIList.forEach(function (nameItem) {
        if (item.employees.includes(nameItem.uuid) && nameItem.name !== '') {
          namesList.push(nameItem.name);
        }
      });
      let namesString: string;
      if (namesList.length) {
        namesString = ' (' + joinWithAnd(namesList) + ')';
      } else {
        namesString = ' (ingen)';
      }
      result.push({
        uuid: item.uuid,
        type: item.type,
        name: item.name + namesString,
        employees: item.employees,
      });
    });
    return result;
  },
);
